// Start Alpine as the last step
document.addEventListener('DOMContentLoaded', () => {
    window.Alpine.start()
})
